export const NO_DEBOUNCE_API = [
  '/uic/console/workspace/info',
  '/transaction/web/account/findAccountByPage',
]
